import { defineMessage } from 'services/localization';

export const messages = {
    openInSourceLinkText: defineMessage('open_in_integrationname'),
    editInSourceLinkText: defineMessage('open_for_editing'),
};
